import React, { useEffect, useRef } from 'react';
import { ParallaxLayer } from 'react-spring/renderprops-addons';
import './JManagedCampaign.scss';
import anime from 'animejs';
import bestInClassIndex from '../assetsV2/managedCampaignIndex';

// 示例图片和数据卡片
const JManagedCampaign = (props) => {
  const {
    pOffset, layoutFactor = 1, offsetAdjust = 0,
  } = props;
  const ref = React.createRef();
  const [activeTab, setActiveTab] = React.useState(0);
  const [pendingTab, setPendingTab] = React.useState(null);
  const cardRef = useRef(null);
  const tabRefs = useRef([]);
  // Tab切换动画
  useEffect(() => {
    if (pendingTab !== null && cardRef.current) {
      anime({
        targets: cardRef.current,
        opacity: [1, 0],
        translateX: [0, -40],
        duration: 320,
        easing: 'easeInCubic',
        complete: () => {
          setActiveTab(pendingTab);
          anime.set(cardRef.current, { translateX: 40 });
          anime({
            targets: cardRef.current,
            opacity: [0, 1],
            translateX: [40, 0],
            duration: 360,
            easing: 'easeOutCubic',
            complete: () => setPendingTab(null),
          });
        },
      });
    }
  }, [pendingTab]);



  const handleTabClick = (idx) => {
    if (idx !== activeTab && pendingTab === null) {
      setPendingTab(idx);
    }
  };

  return (
    <ParallaxLayer
      offset={pOffset + offsetAdjust}
      factor={layoutFactor}
      speed={0}
      className="jmc-bg-layer "
    >
      {/* 顶部大标题 */}
      <div className="brand-d-noiz-title">
        END-TO-END MANAGED<br />CAMPAIGN PROCESS
      </div>
      {/* Tab导航 */}
      <div className="jmc-tabs">
        {bestInClassIndex.map((item, idx) => (
          <div
            key={item.title}
            className={`jmc-tab${activeTab === idx ? ' active' : ''}`}
            ref={el => tabRefs.current[idx] = el}
            onClick={() => handleTabClick(idx)}
          >
            {item.title.toUpperCase()}
          </div>
        ))}
      </div>
      {/* 内容卡片区 */}
      <div className="jmc-card" ref={cardRef}>
        {/* 左侧文字 */}
        <div className="jmc-card-left">
          <div className="jmc-card-title">{bestInClassIndex[activeTab]?.title || ''}</div>
          <div className="jmc-card-desc">
            {bestInClassIndex[activeTab]?.text || ''}
          </div>
        </div>
        {/* 右侧图片/数据卡片 */}
        <div className="jmc-card-right">
          <img src={bestInClassIndex[activeTab]?.image}  className="jmc-tab-image" alt= {bestInClassIndex[activeTab]?.text || ''} />
        </div>
      </div>
      <div ref={ref} />
    </ParallaxLayer>
  );
};

export default JManagedCampaign;

